export default "/assets/website/images/store-6.jpeg?4c5b34332ba43e872712e64c9b388008";